export default "__VITE_ASSET__VWve2$30__"